import React from "react";
import Flex from "../../../../structure/Flex";

interface CheckboxesProps {
  value: any;
  setValue: React.Dispatch<any>;
  name: string;
  options?: Array<{ id: any; value: string }>;
  className?: string;
}

const Checkboxes: React.FC<CheckboxesProps> = ({
  value,
  setValue,
  name,
  options,
  className = "p-3",
}) => {
  const handleChange = (id: any, checked: boolean) => {
    if (checked) {
      setValue([...value.filter((v: any) => v !== id), id]);
    } else {
      setValue([...value.filter((v: any) => v !== id)]);
    }
  };

  return (
    <Flex className="flex-wrap">
      {options &&
        options.map((option) => (
          <Flex inline key={option.id}>
            <input
              type="checkbox"
              value={option.id}
              name={name}
              className="hidden"
              id={`checkbox-${name}-${option.id}`}
              checked={value.indexOf(option.id) !== -1}
              onChange={(e) => {
                handleChange(option.id, e.target.checked);
              }}
            />
            <label
              className={`rounded-lg cursor-pointer mr-2 mb-2 ${
                value.indexOf(option.id) !== -1
                  ? "text-dark border border-dark"
                  : "border border-accent text-subtitle"
              } ${className}`}
              htmlFor={`checkbox-${name}-${option.id}`}
            >
              {option.value}
            </label>
          </Flex>
        ))}
    </Flex>
  );
};

export default Checkboxes;
